/*
const myPath = new TeardropTextPath({
  x: 50,
  y: 50,
  fill: 'black',
  fontSize: 24,
  fontFamily: 'Arial',
  text: 'Initial Text Initial Text Initial Text Initial Text Initial Text Initial Text ',
  width: 300,
  height: 500,
});
console.log("myPath", myPath);
layer.add(myPath);
selectNode(myPath);
layer.draw();
*/
class TeardropTextPath extends BaseTextPath {
  constructor(config) {
    super(config);

    this.className = 'TeardropTextPath';
    this.attrs.type = "teardroptextpath";
    
    this.width(config?.width ?? 250);
    this.height(config?.height ?? 400);
  }


  static getAttrNames() { return ['width', 'height']; }
  static getDefaultAttrs() { return { width: 250, height: 400 }; }


  width(v) {
    if (v === undefined) return this.attrs.width ?? 0;
    this.attrs.width = v;
    this.updatePath();
    return this;
  }


  height(v) {
    if (v === undefined) return this.attrs.height ?? 0;
    this.attrs.height = v;
    this.updatePath();
    return this;
  }


  updatePath() {
    this.setData(this.generateSvgPath(this.width(), this.height()));
  }


  generateSvgPath(width, height, pointUp=true) {
const w = width;
  const h = height;
  const cx = w / 2;               // centre x
  const r  = w / 2;               // radius of the round bulb (half width)

  // The bulb occupies the *wider* half of the height.
  // The remaining height is the tapering tail.
  const bulbHeight = Math.min(h, w);            // never taller than wide
  const tailHeight = h - bulbHeight;

  let d = '';

  if (pointUp) {
    // ── point at top (y = 0) ────────────────────────
    const bulbY = h - bulbHeight;               // y of bulb centre

    d = [
      `M ${cx},0`,                                 // start at tip
      // right side of tail
      `C ${cx + r * 0.55},${tailHeight * 0.7}`,
      `${cx + r},${bulbY}`,
      `${cx + r},${bulbY + r}`,                    // rightmost point of circle
      // arc of the bulb (270° → 90° clockwise)
      `A ${r},${r} 0 1 1 ${cx - r},${bulbY + r}`,
      // left side of tail
      `C ${cx - r},${bulbY}`,
      `${cx - r * 0.55},${tailHeight * 0.7}`,
      `${cx},0`,
      'Z'
    ].join(' ');
  } else {
    // ── point at bottom (y = height) ───────────────
    const bulbY = bulbHeight;                   // y of bulb centre

    d = [
      `M ${cx},${h}`,                              // start at tip
      // right side of tail
      `C ${cx + r * 0.55},${h - tailHeight * 0.7}`,
      `${cx + r},${bulbY}`,
      `${cx + r},${bulbY - r}`,                    // rightmost point of circle
      // arc of the bulb (90° → 270° clockwise)
      `A ${r},${r} 0 1 1 ${cx - r},${bulbY - r}`,
      // left side of tail
      `C ${cx - r},${bulbY}`,
      `${cx - r * 0.55},${h - tailHeight * 0.7}`,
      `${cx},${h}`,
      'Z'
    ].join(' ');
  }

  return d;   

    /*
    const k = size / 210;
    const path = `M0,${200 * k} C0,${150 * k} ${50 * k},${100 * k} ${100 * k},${100 * k} C${150 * k},${100 * k} ${200 * k},${150 * k} ${200 * k},${200 * k} C${200 * k},${250 * k} ${150 * k},${300 * k} ${100 * k},${350 * k} C${50 * k},${300 * k} 0,${250 * k} 0,${200 * k} Z`;
    return path;
    */
  }

}
